export default __webpack_public_path__ + "static/media/tasks-active-icon.0f70f275.svg";